export default {
  error: "Error"
};
